export default __webpack_public_path__ + "static/media/SignupTopRightBanner.3e7e6fa9.png";